import styled from 'styled-components';

const StyleInfinityScroll = styled.div`
  .virtuallist {
    min-height: 50vh;
  }
`;

export default StyleInfinityScroll;
